module.exports = __webpack_public_path__ + "assets/outlook-web-app.ee1db580.svg";